import React from 'react';
import { Container, ListGroup, ListGroupItem } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Swipeable from 'react-swipeable';
//import ReactGA from 'react-ga';

import { setMenuOpen } from '../actions/MenuActions';
import { getHomevideo } from '../actions/VideosActions';
import mainLogo from '../assets/images/curve.svg';
import spbrand from '../assets/images/spbrand.svg';
//import partybg from'../assets/images/partybg.jpg';
import '../styles/App.css';
import '../styles/sp-animate.css';

class Menu extends React.Component {

	componentWillMount(){
		this.props.getHomevideo();
	}

	_goScreen(screen){
		//ReactGA.pageview('/Menu/' + screen);
		this.props.history.push(screen);
		this._toggle();
	}

	_goHome(){
		this.props.history.push({
			pathname: '/home',
			state: { animate: true }
		});
	}

	_toggle(){
		this.props.setMenuOpen(!this.props.open);
	}

	_getAnimate() {
		return this.props.open ? 'appear' : 'vanish'
	}

	render() {
		if (this.props.hide || this.props.showVideo === null) return '';

		return (
			<div className="sp-lt ">

				{/* MENU ENTRA AQUI */}
				<div className={this._getAnimate()}>
					&nbsp;
				</div>

				<Swipeable
					onSwipedUp={() => this._toggle()}
					onSwipedDown={() => this._toggle()}
				>
					<div className={"sp-menu " + (this.props.open ? 'open' : '')}>
						{/* <div className="sp-cvtop" onClick={() => this._toggle()}> */}
						<div className="sp-cvtop" onClick={() => {this._toggle();}}>
							<img  src={mainLogo} alt="Curve" className="svg curve" />
						</div>
						<Container>
							<ListGroup className="sp-list noico">
								<ListGroupItem onClick={() => this._goScreen('about')}>¿QUIENES SOMOS?</ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('photos')}>GALERÍA DE FOTOS</ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('videos')}>VIDEOS DE ARTISTAS </ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('videos_proms')}>VIDEOS DE PROMS </ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('testimonials')}>TESTIMONIALES</ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('package')}>CREA TU PACKAGE</ListGroupItem>
								<ListGroupItem onClick={() => this._goScreen('contact')}>CONTACTO</ListGroupItem>
							</ListGroup>
						</Container>
						<img
							onClick={() => {this._toggle(); this._goHome();}}
							className="sp-logo"
							src={spbrand} alt="Montamos tu Patry brand"
						/>
					</div>
				</Swipeable>

			</div>
		);
	}
}

const mapStateToProps = state => ({
	open: state.MenuReducer.open,
	hide: state.MenuReducer.hide,
	showVideo: state.HomeReducer.showVideo
});

export default withRouter(connect(mapStateToProps, { setMenuOpen, getHomevideo })(Menu));


// WEBPACK FOOTER //
// ./src/components/Menu.js